import { Box, Button, Switch } from "@mui/material";
import {
  DataGrid,
  gridClasses,
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const PlantDetails = () => {
  const [plants, setPlants] = useState([]);
  const orgId = JSON.parse(localStorage.getItem("org"));
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  useEffect(() => {
    const getOrg = async () => {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/organization/get-by-admin?username=${storedUser.username}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      if (
        !res.data.orgLogo &&
        !res.data.orgUsername &&
        !res.data.orgShortform
      ) {
        navigate(`/admin/org-details`);
      }
    };
    getOrg();
  }, []);

  useEffect(() => {
    const getPlants = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/plant/org?orgId=${orgId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setPlants(res.data);
      } catch (error) {
        console.log(error.response.data.Exception || "Access denied");
      }
    };
    getPlants();
  }, []);

  const columns = [
    {
      field: "plantId",
      headerName: "Plant ID",
      flex: 1,
    },
    {
      field: "name",
      headerName: "Plant Name",
      flex: 1,
    },
    {
      field: "gst",
      headerName: "GSTIN",
      flex: 1,
    },
    {
      field: "address",
      headerName: "Address",
      flex: 1,
    },
  ];

  const rows = plants ? plants : "";

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "end" }}>
        <Link to={`/admin/add-plant`}>
          <Button className="btn-contained">+ Add Plant</Button>
        </Link>
      </div>
      <div className="dashboard-container">
        <h1>List of Plants</h1>
        <Box sx={{ background: "#fff" }}>
          <DataGrid
            rows={rows}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 20,
                },
              },
            }}
            pageSizeOptions={[20]}
            disableRowSelectionOnClick
            disableColumnSelector
            disableDensitySelector
            slots={{ toolbar: CustomToolbar }}
            getRowId={(row) => row.plantId}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
            }
            sx={{
              position: "relative",
              border: "none",
              fontFamily: "Inter !important",

              "& .MuiDataGrid-columnHeaderTitle": {
                fontWeight: "700 !important",
              },
              "& .MuiDataGrid-columnHeaders": {
                background: "none !important",
                color: "black",
                fontSize: "14px",
                borderRadius: "10px",
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "#fff",
              },
              "& .MuiDataGrid-cell": {
                fontSize: "13px",
                border: "none",
              },
              "& .MuiDataGrid-columnSeparator": {
                display: "none",
              },
              "& .css-1ccsd5i-MuiButtonBase-root-MuiButton-root": {
                color: "#000 !important",
                border: "1px solid #B0B0B0",
                borderRadius: "12px",
                padding: 1,
              },
              "& .MuiInputBase-root-MuiInput-root::after": {
                borderBottom: "none !important",
              },
              "& .MuiInputBase-root-MuiInput-root": {
                borderBottom: "none !important",
              },
              [`& .${gridClasses.row}.even`]: {
                backgroundColor: "#EAF4FF",
                // '&:hover': {
                //   backgroundColor: "#f6f6f6",
                // },
              },
              "& .MuiInput-underline:before": {
                borderBottom: "none !important",
              },
              "& .css-5h82ro-MuiInputBase-root-MuiInput-root::after": {
                borderBottom: "none !important",
              },
            }}
          />
        </Box>
      </div>
    </div>
  );
};

export default PlantDetails;

function CustomToolbar() {
  return (
    <GridToolbarContainer sx={{ display: "flex", justifyContent: "end" }}>
      <GridToolbarQuickFilter
        sx={{
          border: "1px solid #B0B0B0",
          borderRadius: "12px",
          padding: "4px 12px",
          "&:hover": {
            backgroundColor: "#D8E9F0",
          },
          "& .MuiInputBase-root": {
            borderRadius: "12px",
          },
          width: 300,
        }}
      />
      {/* <GridToolbarFilterButton /> */}
    </GridToolbarContainer>
  );
}